import {useI18n} from 'i18n/I18nContext'
import {CertificateBuilder} from 'organization/Event/Certification/Builder'
import {
  CertificateTemplate,
  TEMPLATES,
} from 'organization/Event/Certification/Builder/templates'
import {getCertificateDefaultFields} from 'organization/Event/Certification/certificateDefaultFields'
import {CertificationConfig} from 'organization/Event/Certification/CertificationHeader'
import EventPage from 'organization/Event/EventPage'
import {EventFaqHelp} from 'organization/Event/Help/FAQ'
import {useOrganizationEvent} from 'organization/Event/OrganizationEventProvider'
import BreadcrumMenu from 'organization/theme/Breadcrum'
import React, {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
export const Certifications = () => {
  const {t} = useI18n()
  const {event, updateEventCertificate, loading} = useOrganizationEvent()
  const newTemplateDefaults = (): CertificateTemplate => ({
    ...TEMPLATES[0],
    fields: getCertificateDefaultFields(t),
  })
  const savedCertificateJson = event?.certificate?.certificate_json
  const [initialTemplate, setInitialTemplate] = useState<CertificateTemplate>(
    () => savedCertificateJson ?? newTemplateDefaults(),
  )
  const [template, setTemplate] = useState<CertificateTemplate>(
    () => savedCertificateJson ?? newTemplateDefaults(),
  )

  useEffect(() => {
    const saved = event?.certificate?.certificate_json
    if (!saved) return
    setTemplate(saved)
    setInitialTemplate(saved)
  }, [event?.certificate?.certificate_json])
  const hasUnsavedChanges = () => {
    return JSON.stringify(initialTemplate) !== JSON.stringify(template)
  }
  const save = async () => {
    const changedCertificate = {
      ...(event?.certificate || {}),
      id: event?.certificate?.id ?? 0,
      event_id: event?.certificate?.event_id ?? event?.id ?? 0,
      certificate_json: template,
    }

    const result = await updateEventCertificate(changedCertificate)

    if (result === true) {
      toast.success(t('orgCert.toastSaved'))
    }

    setInitialTemplate(template)
  }
  return (
    <EventPage>
      <>
        <div className="row pl-30 pb-30 pr-30">
          <BreadcrumMenu
            title={t('org.sidebar.certificates')}
            helpInfo={<EventFaqHelp faqKey="certificatesPage" />}
          />
          <CertificationConfig />
          <div className="col-xxl-12">
            <div className="create__event-area">
              <div className="body__card-wrapper">
                <CertificateBuilder
                  setTemplate={setTemplate}
                  template={template}
                  hasUnsavedChanges={hasUnsavedChanges()}
                />
                <button
                  type="button"
                  disabled={loading}
                  onClick={save}
                  className={
                    loading
                      ? 'disableBtnStyle w-100 mt-30'
                      : 'input__btn w-100 mt-30'
                  }
                >
                  {t('common.save')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    </EventPage>
  )
}
